<template>
    <div class="ns-paginate">
        <div
            v-if="contents !== null"
            :class="{'dark-theme': dark}"
        >
            <slot
                :reset="resetFilters"
                :applyFilters="loadContent"
                :filters-value="filtersValue"
                :allowedFilter="allowedFilter"
                :contents="contents"
                name="filter"
            >
                <div class="blockFilter">
                    <div v-if="displaySearchBar" class="blockSearch blockFlex">
                        <span style="white-space: nowrap;">{{ getSearchText }}</span>
                        <el-input
                            v-model="filtersValue.searchFilter"
                            :placeholder="getVerbose('ns_paginate_search_placeholder')"
                            class="searchInput"
                            @keyup.enter.native="loadContent"

                        >
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div
                        v-if="filters.length > 0"
                        :class="[allowWrap === false ? '': 'flexWrap']"
                        class="blockFlex blockSelect"
                    >
                        <span style="flex-basis: 50px;">{{ getVerbose('ns_paginate_filters_title') }}: </span>
                        <el-row
                            :gutter="40"
                            style="width: 100%;"
                        >
                            <el-col
                                v-for="(listFilter, filterKey) in allowedFilter"
                                :key="filterKey"
                                :xs="selectWitdh.xs || 24"
                                :sm="selectWitdh.sm || 12"
                                :md="selectWitdh.md || 12"
                                :lg="selectWitdh.lg || 12"
                                :xl="selectWitdh.xl || 12"
                            >
                                <filter-select
                                    style="margin-bottom: 15px;"
                                    ref="filterSelect"
                                    :verbose="listFilter.verbose"
                                    :list="listFilter.list"
                                    :filters-values="filtersValue.keysFilter[filterKey]"
                                    :key="filterKey"
                                    :format-function="listFilter.formatFunction"
                                    :defaultValue="listFilter.defaultValue"
                                    @valueUpdated="filtersValue.keysFilter[filterKey] = $event"
                                >
                                </filter-select>
                            </el-col>
                        </el-row>
                    </div>
                    <slot name="custom-input"></slot>
                    <template v-if="displayAdvancedFilter">
                        <div class="switchFilterType">
                            <el-switch
                                v-model="advancedFilter"
                                :active-text="getVerbose('ns_paginate_advanced_filters_switch_active_text')"
                            ></el-switch>
                        </div>
                    </template>
                    <div
                        v-if="advancedFilter"
                        class="advancedFilter"
                    >
                        <el-alert
                            :closable="false"
                            :description="getVerbose('ns_paginate_advanced_filters_description')"
                            :title="getVerbose('ns_paginate_advanced_filters_title')"
                            type="info"
                            style="border: 1px solid #909399; margin-bottom: 15px;"
                            show-icon
                        >
                        </el-alert>
                        <el-button
                            @click="addAdvancedFilter"
                            type="primary"
                            class="addAdvancedFilter"
                        >
                            <i class="el-icon-plus"></i>
                        </el-button>
                        <div
                            v-for="(value, index) in advancedFiltersValue"
                            class="blockAddAdvancedFilter"
                            :key="index"
                        >
                            <el-row :gutter="40">
                                <el-col
                                    :xs="24"
                                    :sm="24"
                                    :md="10"
                                    :lg="10"
                                    :xl="10"
                                >
                                    <el-select
                                        :placeholder="getVerbose('ns_paginate_ns_paginate_advanced_filters_placeholder')"
                                        v-model="value.valueToFilter"
                                        style="width: 100%"
                                        :key="index"
                                    >
                                        <el-option
                                            v-for="item in allowedFilterKeys"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col
                                    :xs="24"
                                    :sm="24"
                                    :md="6"
                                    :lg="6"
                                    :xl="6"
                                >
                                    <el-select
                                        :placeholder="getVerbose('ns_paginate_advanced_filters_compare_placeholder')"
                                        v-model="value.valueComparator"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            :label="getVerbose('ns_paginate_advanced_filters_compare_gt')"
                                            value="gt"
                                        ></el-option>
                                        <el-option
                                            :label="getVerbose('ns_paginate_advanced_filters_compare_gte')"
                                            value="gte"
                                        ></el-option>
                                        <el-option
                                            :label="getVerbose('ns_paginate_advanced_filters_compare_lt')"
                                            value="lt"
                                        ></el-option>
                                        <el-option
                                            :label="getVerbose('ns_paginate_advanced_filters_compare_lte')"
                                            value="lte"
                                        ></el-option>
                                        <el-option
                                            :label="getVerbose('ns_paginate_advanced_filters_compare_range')"
                                            value="range"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                                <el-col
                                    :xs="24"
                                    :sm="24"
                                    :md="5"
                                    :lg="5"
                                    :xl="5"
                                >
                                    <el-input
                                        v-model="value.targetValue"
                                        :placeholder="getVerbose('ns_paginate_advanced_filters_compare_input_placeholder')"
                                        style="width: 100%"
                                    >
                                    </el-input>
                                    <div
                                        v-if="value.valueComparator === 'range'"
                                        class="rangeTip"
                                    >{{ getVerbose('ns_paginate_advanced_filters_compare_input_tip') }}</div>
                                </el-col>
                                <el-col :span="2">
                                    <el-button
                                        icon="el-icon-delete"
                                        @click="deleteAdvancedFiltersValue(index)"
                                        class="deleteAdvancedFiltersValue"
                                    >
                                    </el-button>
                                </el-col>
                                <el-col :span="24">
                                    <p
                                        class="helpFilter"
                                        ref="helpFilter"
                                    ></p>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div
                        class="blockFlex"
                        style="justify-content: flex-end;"
                    >
                        <el-button
                            :icon="windowWidth < 446 ? 'el-icon-refresh-left': ''"
                            style=""
                            @click="resetFilters"
                        >
                            <span v-if="windowWidth > 445">{{ getVerbose('ns_paginate_filters_button_reset') }}</span>
                        </el-button>
                        <el-button
                            :icon="windowWidth < 446 ? 'el-icon-check': ''"
                            style=""
                            type="primary"
                            @click="loadContent"
                        >
                            <span v-if="windowWidth > 445">{{ getVerbose('ns_paginate_filters_button_apply') }}</span>
                        </el-button>
                    </div>
                </div>




            </slot>
            <div
                v-loading="isLoadingContent"
                :element-loading-text="vLoadingData.text"
                :element-loading-spinner="vLoadingData.spinner ? vLoadingData.spinner : ''"
                :element-loading-background="vLoadingData.background ? vLoadingData.background : 'rgba(255, 255, 255, 0.9)'"
                class="tableContainer"
            >
                <slot name="reload">
                    <i
                        class="reloadBtn el-icon-refresh"
                        @click="loadContent"
                    >
                    </i>
                </slot>
                <slot
                    :list="contents.results"
                    :edit="showModalEditObject"
                    name="list"
                >
                    <div class="list">
                        <el-table
                            v-loading="requestIsLoading"
                            v-if="contents.results.length > 0"
                            :data="contents.results"
                            style="width: 100%"
                            @sort-change="sortChange"
                        >
                            <el-table-column
                                v-for="(item, index) in allowedListFieldToDisplay"
                                :key="item.key"
                                :prop="item.key"
                                :label="item.verbose"
                                :formatter="formatListTableCell"
                                sortable="custom"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="index === 0"
                                        type="text"
                                        @click="showModalEditObject(scope.row)"
                                    >
                                        {{ scope.row[item.key] }}
                                    </el-button>
                                    <template v-else>{{ scope.row[item.key] }}</template>
                                </template>
                            </el-table-column>
                            <slot name="custom-column"></slot>
                            <el-table-column
                                v-if="displayStatusColumn"
                                :label="getVerbose('ns_paginate_table_column_status_label')"
                                :prop="getVerbose('ns_paginate_table_column_status_label')"
                                sortable="custom"
                            >
                                <template slot-scope="scope">
                                    <i
                                        v-tooltip.top="screamCaseToSeparateWord(scope.row.status)"
                                        v-if="getRelatedIconStatus(scope.row.status) !== null"
                                        :class="getRelatedIconStatus(scope.row.status)
                                        "
                                        class="statusIcon"
                                    ></i>
                                    <template v-else>
                                        {{ screamCaseToSeparateWord(scope.row.status) }}
                                    </template>
                                </template>
                            </el-table-column>

                            <el-table-column
                                v-if="operationsColumn.length > 0"
                                :label="getVerbose('ns_paginate_table_column_operations_label')"
                                sortable="custom"
                            >

                                <template slot-scope="scope">
                                    <operation-column
                                        :operations-column="operationsColumn"
                                        :row-item="scope.row"
                                    ></operation-column>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div
                            v-else
                            v-loading="requestIsLoading"
                        >
                            <p style="text-align: center;">{{ getVerbose('ns_paginate_table_empty') }}</p>
                        </div>
                    </div>
                </slot>
            </div>
            <div class="flexCenter">
                <slot
                    name="pagination"
                    :currentPage="currentPage"
                    :pageCount="contents.num_total_pages"
                >
                    <el-pagination
                        v-if="contents.num_total_pages > 1"
                        background
                        :layout="`${windowWidth < 500 ? '': 'sizes, '}prev, pager, next`"
                        :small="windowWidth < 500"
                        :page-size="itemPerPage"
                        :page-sizes="pagesSize"
                        :page-count="contents.num_total_pages"
                        :current-page="currentPage"
                        @current-change="loadSpecificPage"
                        @size-change="onSizeChange"
                    >
                    </el-pagination>
                </slot>
                <csv-button
                    v-if="displayCsvButton"
                    :url="applyFilters"
                    :model-name="baseUrl.split('/')[0]"
                    :scoped="scoped"
                    style="margin-left: 20px;"
                >
                </csv-button>
            </div>
        </div>
        <template v-else>
            <slot name="loader">
                <div
                    v-loading="requestIsLoading"
                    class="blockLoading"
                >
                </div>
            </slot>
        </template>
    </div>
</template>
<script>
import moment from 'moment';
import FilterSelect from './filter-select.vue';
import CsvButton from './download-csv-button.vue';
import ModalDetail from './modal-detail.vue';
import ModalForm from '../modal-form.js';
import OperationColumn from './operations-column.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        FilterSelect,
        CsvButton,
        OperationColumn,
    },
    props: {
        baseUrl: {
            type: String,
            required: true,
        },
        scoped: {
            type: Boolean,
            default: true,
        },
        filters: {
            type: Array,
            default: () => {
                return [];
            },
        },
        listFieldToDisplay: {
            type: Array,
            default: () => {
                return [];
            },
        },
        searchText: {
            type: String,
            default: undefined
        },
        customFiltersToApply: {
            type: Function,
            default: () => {
                return {};
            },
        },
        onResetFilters: {
            type: Function,
            default: () => {
                return {};
            },
        },
        allowWrap: {
            type: Boolean,
            default: false,
        },
        selectWitdh: {
            type: Object,
            default () {
                return {
                    xs: 24,
                    sm: 12,
                    md: 12,
                    lg: 12,
                    xl: 12
                };
            }, // valeur en %
        },
        displayCsvButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        displayAdvancedFilter: {
            type: Boolean,
            default: false,
        },
        displaySearchBar: {
            type: Boolean,
            default: true,
        },
        canEditModel: {
            type: Boolean,
            default: false,
        },
        model: {
            type: String,
            required: false,
            default: '',
        },
        overrideDisplay: {
            type: Object,
            default () {
                return {};
            },
        },
        // deleted, on editOptions now
        extraHiddenKeys: {
            type: Array,
            default () {
                return [];
            },
        },
        editOptions: {
            type: Object,
            required: false,
            default (){
                return {};
            }
        },
        vLoadingData: {
            type: Object,
            default () {
                return {};
            },
        },
        customItemPageLength: {
            type: Number,
            required: false,
            default: 10,
        },
        customStatus: {
            type: Object,
            required: false,
            default (){
                return {};
            },
        },
        operationsColumn: {
            type: Array,
            required: false,
            default (){
                return [];
            },
        },
        dark: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            windowWidth: 0,
            maxItemPerPage: 10,
            currentPage: 1,
            fetchedFilters: null,
            contents: null,
            // c'est valeur sont encapsuler dans un object pour pouvoir etre surcharger en cas de slot voir: https://github.com/vuejs/vue/issues/5594
            filtersValue: {
                searchFilter: '',
                keysFilter: {},
            },
            regexDate: /(,?\d{4}-\d{2}-\d{2},?)/g,
            advancedFilter: false,
            itemPerPage: 2,
            filterOpen: false,
            requestIsLoading: true,
            initialised: false,
            isLoadingContent: false,
            advancedFiltersValue: [{
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            }],
            ordering: false,
            orderingProperty: {
                sign: '',
                property: ''
            },
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        getSearchText() {
            return this.searchText || this.getVerbose('ns_paginate_search_title');
        },
        pagesSize() {
            return [10, 25, 50, 100];
        },

        displayStatusColumn (){
            return this.listFieldToDisplay.find((item) => item.key === 'status');
        },

        allowedListFieldToDisplay() {
            return this.listFieldToDisplay.filter((field) => {
                // [0] car on 'this.contents.results' et la liste des models et tous les models ont la même signature. Donc pour rechercher si une clé existe sur un model in peu prendre n'importe lequel
                return this.contents.results[0].hasOwnProperty(field.key) && field.key !== 'status';
            });
        },
        allowedFilter() {
            let allowedFilters = {};
            for (let key in this.fetchedFilters) {
                let associatedFilter = this.filters.find((filter) => {
                    return filter.key === key;
                });
                if (associatedFilter !== undefined) {
                    let defaultValue = '';
                    if (typeof associatedFilter.defaultValue === 'string') {
                        defaultValue = this.fetchedFilters[key].includes(associatedFilter.defaultValue) ? associatedFilter.defaultValue : '';
                    } else if (associatedFilter.defaultValue instanceof Array) {
                        defaultValue = [];
                        defaultValue.push(...associatedFilter.defaultValue.filter((value) => {
                            return this.fetchedFilters[key].includes(value);
                        }));
                    }
                    let formatFunction = associatedFilter.hasOwnProperty('formatFunction') ? associatedFilter.formatFunction : (data) => {
                        return data;
                    };
                    allowedFilters[key] = {
                        list: this.fetchedFilters[key],
                        verbose: associatedFilter.verbose,
                        formatFunction: formatFunction,
                        defaultValue: defaultValue,
                    };
                }
            }
            return allowedFilters;
        },
        allowedFilterKeys() {
            return Object.keys(this.allowedFilter);
        }
    },

    watch: {
        customItemPageLength (val){
            this.itemPerPage = val;
            this.loadContent();
        },
    },
    created() {
        this.itemPerPage = this.customItemPageLength || this.pagesSize[0];
        if(this.extraHiddenKeys.length > 0){
            console.warn('extraHiddenKeys IS NOT A PROPS ANYMORE, IT IS IN editOptions. EXAMPLE editOptions.extraHiddenKeys = [...]');
        }
    },
    mounted: function() {
        this.loadContent();
        this.setWindowWidthForNsPaginate();
        window.addEventListener('resize', this.setWindowWidthForNsPaginate);
    },
    destroyed() {
        window.removeEventListener('resize', this.setWindowWidthForNsPaginate);
    },
    methods: {
        formatListTableCell (row, column, cellValue, index){
            let relatedFieldToDisplay = this.allowedListFieldToDisplay.find((field) => field.key === column.property);
            if(relatedFieldToDisplay && relatedFieldToDisplay.hasOwnProperty('property')){
                return cellValue[relatedFieldToDisplay.property];
            }
            return cellValue;
        },

        setWindowWidthForNsPaginate() {
            this.windowWidth = window.innerWidth;
        },
        screamCaseToSeparateWord (word){
            return word.replace(/\_/g, ' ');
        },

        getRelatedIconStatus (status){

            if(status === 'FAILED' || this.hasRelatedCustomStatus('failed', status)){
                return 'el-icon-error';
            }else if(status === 'TIMEOUT' || this.hasRelatedCustomStatus('timeout', status)){
                return 'ti-time';
            }else if(status === 'COMPLETED' || this.hasRelatedCustomStatus('completed', status)){
                return 'el-icon-success';
            }else if(status === 'PENDING' || this.hasRelatedCustomStatus('pending', status)){
                return 'ti-line-dotted ';
            }else if(status === 'RUNNING' || this.hasRelatedCustomStatus('running', status)){
                return 'el-icon-loading';
            }else{
                return null;
            }
        },

        hasRelatedCustomStatus (status, statusToMatch){
            if(this.customStatus.hasOwnProperty(status)){
                return this.customStatus[status].includes(statusToMatch);
            }
            return false;
        },

        showModalEditObject(object) {
            ModalForm.display(
                this,
                ModalDetail,
                {
                    attrs: object,
                    customClassName: 'modal-edit',
                    overrideDisplay: this.overrideDisplay,
                    store: this.$store,
                    editOptions: this.editOptions,
                    getVerbose: this.getVerbose,
                    readOnly: !this.canEditModel,
                },
                this.getVerbose('ns_paginate_modal_information_title'),
                this.handleObjectEdition,
                {
                    showConfirmButton: this.canEditModel ? true : false,
                    cancelButtonTextStored: this.canEditModel ? 'cancel' : 'close',
                },
            );
        },
        handleObjectEdition(val) {
            if (!this.model) {
                console.error(this.getVerbose('ns_paginate_modal_information_edit_props_error'));
                return;
            }
            return this.$store.dispatch(
                'patchItem', {
                    item: val,
                    model: this.model,
                }
            ).then(() => {
                this.$notify.success({
                    title: this.getVerbose('ns_paginate_modal_information_edit_success_title'),
                    message: this.getVerbose('ns_paginate_modal_information_edit_success_desc'),
                });
                this.loadContent();
            }).catch((error) => {
                this.$notify.warning({
                    title: this.getVerbose('ns_paginate_modal_information_edit_error_title'),
                    message: this.getVerbose('ns_paginate_modal_information_edit_error_desc'),
                });
                console.error(error);
            });
        },
        addAdvancedFilter() {
            this.advancedFiltersValue.push({
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            });
        },
        deleteAdvancedFiltersValue(index) {
            if (this.advancedFiltersValue.length > 1) {
                this.advancedFiltersValue.splice(index, 1);
            }
        },
        onSizeChange(val) {
            this.itemPerPage = val;
            this.loadContent();
        },
        loadContent(event, params = '') {
            // quand la fonction est appelé depuis le button applyFilter le premier parametre passé est l'event du click du button
            // mais quand la fonction est appelé par 'loadSpecificPage' on veux passer 'params' en parametre
            if (this.ordering) {
                params.ordering = `${this.orderingProperty.sign}${this.orderingProperty.property}`;
            }
            let url = this.applyFilters(params);
            let filterUrl = `${this.baseUrl}${'sets/'}${this.applyFilterSeparator(this.customFiltersToApply())}`;
            if (!url) return;
            this.requestIsLoading = true;
            this.isLoadingContent = true;
            const scopes = (this.scoped) ? this.$store.state.api.scopes : {};
            const config = {
                headers: scopes
            };
            Promise.all(
                [
                    this.$store.axios.get(url, config),
                    this.$store.axios.get(filterUrl, config)
                ]
            ).then((response) => {
                this.isLoadingContent = false;
                this.requestIsLoading = false;
                this.contents = response[0].data;
                this.resetHelpText();
                this.currentPage = params.hasOwnProperty('page') ? params.page : 1;
                this.$set(this, 'fetchedFilters', response[1].data.sets);
                // obliger de créer les clés pour 'keysFilter' sinon le select en multiple de element ui est pas content
                if (Object.keys(this.filtersValue.keysFilter).length === 0) {
                    let keys = Object.keys(this.allowedFilter);
                    let filters = {};
                    for (let key of keys) {
                        filters[key] = [];
                    }
                    this.$set(this.filtersValue, 'keysFilter', filters);
                }
                this.$emit('input', this.contents);
            }).catch((e) => {
                console.error(e);
            });
        },
        loadSpecificPage(number) {
            let params = {
                'page': number
            };
            this.loadContent(null, params);
        },
        resetHelpText() {
            for (let i = 0; i < this.advancedFiltersValue.length; i++) {
                if (this.$refs.helpFilter) {
                    this.$refs.helpFilter[i].classList.remove('helpFilterError');
                    this.$refs.helpFilter[i].innerText = '';
                }
            }
        },
        resetFilters() {
            for (let key in this.filtersValue.keysFilter) {
                if (this.filtersValue.keysFilter[key] instanceof Array) {
                    this.filtersValue.keysFilter[key] = [];
                } else {
                    this.filtersValue.keysFilter[key] = '';
                }
            }
            this.onResetFilters();
            this.filtersValue.searchFilter = '';
            if (Object.keys(this.allowedFilter).length > 0) {
                this.$refs.filterSelect.forEach((item) => {
                    item.resetCalled();
                });
            }
            this.advancedFiltersValue = [{
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            }];
            this.loadContent();
        },
        applyFilters(params = '') {
            let additional = this.customFiltersToApply();
            additional['c_resp_page_size'] = this.itemPerPage;
            let url = this.baseUrl;
            let filterToApply = {
                // search: this.filtersValue.searchFilter
            };
            // !! check for !== '', !== null, !== undefined, !== false, !== 0
            if (!!this.filtersValue.searchFilter) {
                filterToApply.search = this.filtersValue.searchFilter;
            }
            // appeler seulement la première fois (car apres fetchedFilters contient la liste des filtres)/ Permet de mettre une valeur par défaut dans les filtres sélectionnable pas l'utilisateurs.
            if (this.fetchedFilters === null) {
                for (let filter of this.filters) {
                    if (filter.hasOwnProperty('defaultValue')) {
                        if (typeof filter.defaultValue === 'string' && filter.defaultValue !== '') {
                            this.$set(this.filtersValue.keysFilter, filter.key, [filter.defaultValue]);
                        } else if (filter.defaultValue instanceof Array) {
                            this.$set(this.filtersValue.keysFilter, filter.key, filter.defaultValue);
                        }
                    } else {
                        this.filtersValue.keysFilter[filter.key] = [];
                    }
                }
            }
            // ADD FILTER
            for (let key in this.filtersValue.keysFilter) {
                let filterValue = this.filtersValue.keysFilter[key];
                if (filterValue instanceof Array) {
                    if (filterValue.length > 1) {
                        filterToApply[`${key}__in`] = filterValue;
                    } else if (filterValue.length > 0) {
                        filterToApply[key] = filterValue[0];
                    }
                } else if (!!filterValue) {
                    filterToApply[key] = filterValue;
                }
            }
            // ADD ADVANCED FILTER VALUE
            let hasError = false;
            if (this.advancedFilter && this.displayAdvancedFilter) {
                let count = 0;
                for (let item of this.advancedFiltersValue) {
                    let helpText = this.$refs.helpFilter[count];
                    let itemValues = Object.values(item);
                    if (itemValues.every((val) => val !== '' && val !== null)) {
                        hasError = this.checkAdvancedFilterValidation(item, helpText);
                        let checkedItem = this.handleDateCase(item);
                        filterToApply[`${checkedItem.valueToFilter}__${checkedItem.valueComparator}`] = checkedItem.targetValue;
                    } else {
                        helpText.innerText = this.getVerbose('advanced_filters_help_text');
                        helpText.classList.add('helpFilterNotice');
                    }
                    count++;
                }
            }
            if (hasError) return;
            filterToApply = Object.assign(filterToApply, additional, params);
            let urlParams = this.applyFilterSeparator(filterToApply);
            url = `${url}${urlParams}`;
            url = encodeURI(url);
            return url;
        },
        applyFilterSeparator(allFilters) {
            let urlParams = '';
            let count = 0;
            for (let filterKey in allFilters) {
                let filterValue = allFilters[filterKey];
                if (count === 0) {
                    urlParams += '?';
                } else {
                    urlParams += '&';
                }
                if (filterValue !== '') {
                    urlParams += `${filterKey}=${filterValue}`;
                }
                count++;
            }
            return urlParams;
        },
        checkAdvancedFilterValidation(item, helpText) {
            let hasError = false;
            if (item.targetValue.match(/[a-z]+/g)) {
                hasError = true;
                helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_error_message_type');
            } else if (item.valueComparator === 'range') {
                if (!item.targetValue.match(this.regexDate) && !item.targetValue.match(/(\d+,\d+)/g)) {
                    hasError = true;
                    helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_range_error_message_type');
                }
                if (item.targetValue.match(this.regexDate)) {
                    let dates = item.targetValue.split(',');
                    if (moment(dates[1]).isBefore(moment(dates[0]))) {
                        hasError = true;
                        helpText.innerText = this.getVerbose('ns_paginate_advanced_filters_range_error_message_date');
                    }
                }
            }
            if (hasError) helpText.classList.add('helpFilterError');
            return hasError;
        },
        handleDateCase(item) {
            // le greater than et lower than ne fonctionne pas avec les dates mais avec range on peux utiliser date,vide pour gt et vide,date pour lt
            // afin de faciliter l'utilisation à l'utilisateur, si celui-ci utilise un gt,lt,gte,lte avec une date j'envoie en range coté server
            let checkedItem = JSON.parse(JSON.stringify(item));
            if (checkedItem.targetValue.match(this.regexDate) && checkedItem.valueComparator !== 'range') {
                if (checkedItem.valueComparator === 'gt' || checkedItem.valueComparator === 'gte') {
                    checkedItem.targetValue = `${checkedItem.targetValue},`;
                    checkedItem.valueComparator = 'range';
                } else if (checkedItem.valueComparator === 'lt' || checkedItem.valueComparator === 'lte') {
                    checkedItem.targetValue = `,${checkedItem.targetValue}`;
                    checkedItem.valueComparator = 'range';
                }
            }
            return checkedItem;
        },
        sortChange(sortValue) {
            let sign = '';
            if (sortValue.order === 'descending') sign = '-';
            this.$set(this, 'orderingProperty', {
                sign: sign,
                property: sortValue.prop
            });
            this.ordering = true;
            this.loadContent(null, {
                'ordering': `${sign}${sortValue.prop}`
            });
        }
    },
};

</script>
<style lang="scss">
.ns-paginate{
    .advancedFilter {
        margin: 15px 0;

        .blockAddAdvancedFilter {
            position: relative;
            margin-bottom: 20px;
        }

        .addAdvancedFilter,
        .switchFilterType {
            margin-bottom: 15px;
            padding: 5px 5px;
            font-size: 15px;
        }

        .deleteAdvancedFiltersValue,
        .switchFilterType {
            padding: 5px 5px;
            font-size: 15px;
            margin-top: 5px;
        }

        .rangeTip {
            color: grey;
            font-size: 12px;
        }
    }

    .blockFilter {
        margin-bottom: 30px;
        padding: 15px;
        background-color: #f4f4f5;

        .blockFlex {
            display: flex;
            // flex-wrap: wrap;
            align-items: center;

            &>*:not(:first-child) {
                margin-left: 15px;
            }
        }

        .flexWrap {
            flex-wrap: wrap;
        }

        .blockSearch {
            margin-bottom: 15px;

            .searchInput input {
                // border-radius: 24px;
            }
        }

        .blockSelect {

            margin-bottom: 15px;

            input {
                //     background-color: rgba(0,0,0,0);
                //     border: none;
                //     color: red;

                &::placeholder {
                    color: #606266;
                    opacity: 1;
                }
            }
        }
    }

    .reloadBtn {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 1;
        transition: all .3s;
        color: #afafaf;
        font-size: 25px;
        cursor: pointer;

        &:hover {
            transform: scale(1.1);
            color: #000;
            // font-weight: bold;
        }

        &:hover:after {
            content: "Refresh";
            font-family: Montserrat;
            position: absolute;
            top: 30px;
            left: -3px;
            font-size: 12px;
            // font-weight: bold;
        }
    }

    .tableContainer {
        position: relative;
    }

    .list {
        margin-bottom: 30px;

        .statusIcon{
            margin-left: 30px;
            font-size: 18px;
            &.el-icon-error{
                color: #F56C6C;
            }
            &.el-icon-success{
                color: #67C23A;
            }
            &.ti-time{
                color: #fff;
                background-color: #F56C6C;
                padding: 5px;
                border-radius: 15px;
                font-size: 9px;
                font-weight: bold;
            }
        }
    }

    .ns-paginate-container {
        padding: 0;
        @media (min-width: 500px) {
            padding: 30px;
        }
    }

    .flexCenter {
        display: flex;
        justify-content: center;
        align-items: center;

        .item {
            margin: 0 5px;
            background-color: #bdbdbd;
            padding: 5px 12px;
            cursor: pointer;
            font-family: monospace;
        }

        .disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }

        .currentPage {
            background-color: darken(#bdbdbd, 20%);
        }

    }

    .blockLoading {
        height: 400px;
        width: 100%;
        margin: 30px;

        background-color: rgba(255, 255, 255, .9);
    }

    .helpFilter {
        position: absolute;
    }

    .helpFilterError {
        color: red;
    }

    .helpFilterNotice {
        color: grey;
    }
    &.dark-theme {
        .el-loading-mask {
            background-color: rgba(82, 82, 82, .9);
        }
        .el-table__empty-block {
            background-color: #2E3035;
            color: #EAEBEF;
        }
        &::before {
            background-color: #2E3035;
        }
        .el-table__header-wrapper {
            background-color: #57595D;
            border-bottom: 1px solid #393B40;
        }
        thead {
            tr {
                th {
                    color: #EAEBEF;
                    background-color: #57595D;
                    border: none;
                }
            }
        }
        .el-table__row {
            td {
                color: #EAEBEF;
                background-color: #2E3035;
                border-color: #393B40;
            }
            &:hover {
                td {
                    background-color: #37393D;
                }
            }
        }
    }

}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate/index.vue